import { GetResponseData, GetResponse } from '@customTypes/api/UserMarketingId';
import { Endpoints, KrakendServiceAPI } from '@service/index';
import queryKeys from '@src/queries/keys';

import { useQuery } from '../helper/useQuery';

const useGetUserMarketingId = (enabled = true) =>
  useQuery<GetResponseData[]>(
    [queryKeys.UserMarketingId],
    () =>
      KrakendServiceAPI.get<null, GetResponse>(
        Endpoints.UserMarketingId(),
      ).then(response => response.data.data),
    {
      enabled,
      cacheTime: 300,
      staleTime: 500,
    },
  );

export default useGetUserMarketingId;
